// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpressSetupPlanExtendedDto } from './IExpressSetupPlanExtendedDto';
import {
    IExpressSetupPlanExtendedDtoFromJSON,
    IExpressSetupPlanExtendedDtoFromJSONTyped,
    IExpressSetupPlanExtendedDtoToJSON,
    IExpressSetupPlanExtendedDtoToJSONTyped,
} from './IExpressSetupPlanExtendedDto';
import type { IExpressSetupAddressDto } from './IExpressSetupAddressDto';
import {
    IExpressSetupAddressDtoFromJSON,
    IExpressSetupAddressDtoFromJSONTyped,
    IExpressSetupAddressDtoToJSON,
    IExpressSetupAddressDtoToJSONTyped,
} from './IExpressSetupAddressDto';
import type { IExpressSetupPlanYearDto } from './IExpressSetupPlanYearDto';
import {
    IExpressSetupPlanYearDtoFromJSON,
    IExpressSetupPlanYearDtoFromJSONTyped,
    IExpressSetupPlanYearDtoToJSON,
    IExpressSetupPlanYearDtoToJSONTyped,
} from './IExpressSetupPlanYearDto';
import type { IExpressSetupHealthPlanDto } from './IExpressSetupHealthPlanDto';
import {
    IExpressSetupHealthPlanDtoFromJSON,
    IExpressSetupHealthPlanDtoFromJSONTyped,
    IExpressSetupHealthPlanDtoToJSON,
    IExpressSetupHealthPlanDtoToJSONTyped,
} from './IExpressSetupHealthPlanDto';
import type { IExpressSetupCopayDto } from './IExpressSetupCopayDto';
import {
    IExpressSetupCopayDtoFromJSON,
    IExpressSetupCopayDtoFromJSONTyped,
    IExpressSetupCopayDtoToJSON,
    IExpressSetupCopayDtoToJSONTyped,
} from './IExpressSetupCopayDto';
import type { IExpressSetupAccountDto } from './IExpressSetupAccountDto';
import {
    IExpressSetupAccountDtoFromJSON,
    IExpressSetupAccountDtoFromJSONTyped,
    IExpressSetupAccountDtoToJSON,
    IExpressSetupAccountDtoToJSONTyped,
} from './IExpressSetupAccountDto';

/**
 * 
 * @export
 * @interface IExpressSetupJsonExtendedDto
 */
export interface IExpressSetupJsonExtendedDto {
    /**
     * 
     * @type {Array<IExpressSetupPlanExtendedDto>}
     * @memberof IExpressSetupJsonExtendedDto
     */
    plans?: Array<IExpressSetupPlanExtendedDto>;
    /**
     * 
     * @type {IExpressSetupAccountDto}
     * @memberof IExpressSetupJsonExtendedDto
     */
    account?: IExpressSetupAccountDto;
    /**
     * 
     * @type {IExpressSetupPlanYearDto}
     * @memberof IExpressSetupJsonExtendedDto
     */
    plan_year?: IExpressSetupPlanYearDto;
    /**
     * 
     * @type {IExpressSetupHealthPlanDto}
     * @memberof IExpressSetupJsonExtendedDto
     */
    health_plan?: IExpressSetupHealthPlanDto;
    /**
     * 
     * @type {Array<IExpressSetupCopayDto>}
     * @memberof IExpressSetupJsonExtendedDto
     */
    copays?: Array<IExpressSetupCopayDto>;
    /**
     * 
     * @type {IExpressSetupAddressDto}
     * @memberof IExpressSetupJsonExtendedDto
     */
    address?: IExpressSetupAddressDto;
}

/**
 * Check if a given object implements the IExpressSetupJsonExtendedDto interface.
 */
export function instanceOfIExpressSetupJsonExtendedDto(value: object): value is IExpressSetupJsonExtendedDto {
    return true;
}

export function IExpressSetupJsonExtendedDtoFromJSON(json: any): IExpressSetupJsonExtendedDto {
    return IExpressSetupJsonExtendedDtoFromJSONTyped(json, false);
}

export function IExpressSetupJsonExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupJsonExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IExpressSetupPlanExtendedDtoFromJSON)),
        'account': json['account'] == null ? undefined : IExpressSetupAccountDtoFromJSON(json['account']),
        'plan_year': json['plan_year'] == null ? undefined : IExpressSetupPlanYearDtoFromJSON(json['plan_year']),
        'health_plan': json['health_plan'] == null ? undefined : IExpressSetupHealthPlanDtoFromJSON(json['health_plan']),
        'copays': json['copays'] == null ? undefined : ((json['copays'] as Array<any>).map(IExpressSetupCopayDtoFromJSON)),
        'address': json['address'] == null ? undefined : IExpressSetupAddressDtoFromJSON(json['address']),
    };
}

export function IExpressSetupJsonExtendedDtoToJSON(json: any): IExpressSetupJsonExtendedDto {
    return IExpressSetupJsonExtendedDtoToJSONTyped(json, false);
}

export function IExpressSetupJsonExtendedDtoToJSONTyped(value?: IExpressSetupJsonExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IExpressSetupPlanExtendedDtoToJSON)),
        'account': IExpressSetupAccountDtoToJSON(value['account']),
        'plan_year': IExpressSetupPlanYearDtoToJSON(value['plan_year']),
        'health_plan': IExpressSetupHealthPlanDtoToJSON(value['health_plan']),
        'copays': value['copays'] == null ? undefined : ((value['copays'] as Array<any>).map(IExpressSetupCopayDtoToJSON)),
        'address': IExpressSetupAddressDtoToJSON(value['address']),
    };
}

